import { useWsjAdSectionKeyValuesQuery } from 'data/generated/graphql';

/**
 * Hook to fetch WSJAdSectionKey values from the backend as strings.
 * Returns values like 'TOP_NEWS', 'BUSINESS', 'FREE-EXPRESSION', 'PIANO-ACCESS-TESTING'
 * (Note: Most values use underscores, but some legacy values contain hyphens)
 */
export const useWsjAdSectionKeyValues = () => {
  const { data, isLoading, error } = useWsjAdSectionKeyValuesQuery();

  return {
    sectionKeyValues: data?.wsjAdSectionKeyValues ?? [],
    loading: isLoading,
    error
  };
};
